import { createContext, useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { CartContext } from "./CartContext";

export const CardsContext = createContext();

export const CardsProvider = ({ children }) => {

    // const { cart, fetchCart } = useContext(CartContext);
//   const [cards, setCards] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showPast, setShowPast] = useState(false);
  const [customerCards, setCustomerCards] = useState([]);

  const token = typeof window !== "undefined" 
    ? localStorage.getItem("token") 
    : null;

  const fetchCards = async () => {
    setLoader(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/eventOfRecipient/get-customer-cards`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );

      const data = await res.json();
      setLoader(false);

      if (data.data) {
        const currentDate = new Date();
        const filteredAndSortedCards = data.data
          .filter((card) => {
            const eventDate = new Date(card.eventDate);
            const createdAtDate = new Date(card.createdAt);
            const isPastEvent =
              eventDate < currentDate && card.status === "completed";
            // this was for completed in isPastEvent
            // && card.status === "completed"
            const isFutureEvent = eventDate > currentDate;
            return showPast
              ? isPastEvent
              : (isFutureEvent &&
                  (card.status === "pending" || card.status === "completed")) ||
                  (createdAtDate > eventDate &&
                    (card.status === "pending" || card.status === "completed"));
          })
          .sort((a, b) => (a.status === "completed" ? -1 : 1));
        const filteredResults = data?.data?.length
          ? data.data.filter((item) => item.status !== "draft")
          : [];

        setCustomerCards(filteredResults);
      }
    } catch (error) {
      setLoader(false);
      toast.error("Failed to fetch cards.");
    }
  };

  useEffect(() => {
    if (token) fetchCards();
  }, [token]);

  return (
    <CardsContext.Provider value={{ showPast, loader, fetchCards, customerCards, setCustomerCards  }}>
      {children}
    </CardsContext.Provider>
  );
};
